module.exports = __webpack_public_path__ + "static/media/rapbu.c1aa70c3.png";